
import ModuleBase, { ViewLayer, moduleInit, bindButtonClickEvent, implementFunction } from "../../../framework/core/mvvm/module_base";
import ClubBankView from "./clubbank_view";
import ModuleManager from "../../../framework/core/module_manager";
import LanguageManager from "../../../manager/language_manager";
import UserDataManager, { IUserCurrencyData } from "../../../manager/user_manager";
import { club_utils } from "../club_utils";
import AudioManager from "../../../manager/audio_manager";
import Utility from "../../../utility/utility";
import AppData from "../../public/const/app_data";
import ModelData, { IUserData } from "../../public/model_data";
import EventManager from "../../../manager/event_manager";
const { ccclass, property } = cc._decorator;
export enum BankOperate {
    Null = 0,
    SetPassword = 1,
    Save = 2,
    WithDraw = 3,
    Transfer = 4,
    FriendId = 5,
}
@ccclass
@moduleInit("ClubBank")
export default class ClubBank extends ModuleBase<ClubBankView, null> {

    clubData
    bankStatus: BankOperate = BankOperate.Null
    isSetPassword: boolean
    operateMoney: number
    targetUserId: string = ""
    recordType = 0
    recorRequstTime = [0, 0]
    bankMoney
    carryMoney
    lockMoney = 0
    constructor() {
        super();
        this.layer = ViewLayer.Mid;
        this.windowPrefabResPath = "package/club/module/clubbank";
        this.viewType = ClubBankView;
        this.modelType = null;
        this.needAnim = false
        this.needViewMask = true
    }
    protected onButtonClick(node: cc.Node) {
        if (node.parent.name == "numberInputButton") {
            if (this.bankStatus == BankOperate.Null) {
                return
            }
            this.view.numberInputDeal(node.name)
        }
    }
    @bindButtonClickEvent("CloseBtn")
    closeBtn() {
        this.hide()
    }
    @bindButtonClickEvent("PasswordSureBtn")
    PasswordSureBtn() {
        if (this.bankStatus == BankOperate.Null) {
            return
        }
        let pw = this.view.getPassword()
        if (pw != null) {
            this.view.pauseBtnClick(true)
            switch (this.bankStatus) {
                case BankOperate.SetPassword:
                    this.setPassward(pw)
                    break;
                case BankOperate.Save:
                    this.saveMoney(this.operateMoney, pw)
                    break;
                case BankOperate.WithDraw:
                    this.withDrawMoney(this.operateMoney, pw)
                    break;
                case BankOperate.Transfer:
                    this.transferMoney(this.operateMoney, pw, this.targetUserId)
                    break;
            }
        }
    }
    @bindButtonClickEvent("PasswordCancelBtn")
    PasswordCancelBtn() {
        this.bankStatus = this.isSetPassword ? BankOperate.Null : BankOperate.SetPassword
        this.view.operatePanelDeal(this.bankStatus)

        if (this.bankStatus != BankOperate.SetPassword) {
            this.view.moneyInputAnim(2)
        }
    }
    @bindButtonClickEvent("SaveMoneyBtn")
    SaveMoneyBtn() {
        this.bankStatus = BankOperate.Save
        this.view.operatePanelDeal(this.bankStatus)
        this.moneyInputDeal()
    }
    @bindButtonClickEvent("WithDrawMoneyBtn")
    WithDrawMoneyBtn() {
        this.bankStatus = BankOperate.WithDraw
        this.view.operatePanelDeal(this.bankStatus)
        this.moneyInputDeal()
    }
    @bindButtonClickEvent("OperateSureBtn")
    OperateSureBtn() {
        let self = this
        if (this.bankStatus == BankOperate.FriendId) {
            this.targetUserId = this.view.friendInputBox.string
            if (this.targetUserId.length != 8 && (AppData.testMode && this.targetUserId.length != 3)) {
                ModuleManager.instance.toast(LanguageManager.t("clubbank_error1"));
            } else {
                if (this.targetUserId == ModelData.instance.roleData.id.toString()) {
                    ModuleManager.instance.toast(LanguageManager.t("clubbank_error6"));
                    return
                }
                UserDataManager.getData(parseInt(this.targetUserId), function (userData: IUserData) {
                    if (userData == null) {
                        ModuleManager.instance.toast(LanguageManager.t("clubbank_error7"));
                        return
                    }
                    self.view.transferInfo(userData)
                    self.bankStatus = BankOperate.Transfer
                    self.view.operatePanelDeal(self.bankStatus)
                    self.moneyInputDeal()
                })
            }
        } else {
            if (this.view.moneyOperateInputBox.string != "") {
                if (this.view.moneyOperateInputBox.string.indexOf('.') != -1) {
                    ModuleManager.instance.toast(LanguageManager.t("clubbank_error5"));
                    return;
                }
                this.operateMoney = parseInt(this.view.moneyOperateInputBox.string)
                let max
                if (this.operateMoney == 0) {
                    ModuleManager.instance.toast(LanguageManager.t("clubbank_error5"));
                    return;
                }
                if (this.bankStatus == BankOperate.Save) {
                    max = this.carryMoney
                    if (this.operateMoney > this.carryMoney) {
                        ModuleManager.instance.toast(LanguageManager.t("clubbank_error2"));
                    } else {
                        this.saveMoney(this.operateMoney, '')
                    }
                    return;
                } else if (this.bankStatus == BankOperate.WithDraw) {
                    max = this.bankMoney - this.lockMoney
                    if (this.operateMoney > this.bankMoney - this.lockMoney) {
                        ModuleManager.instance.toast(LanguageManager.t("clubbank_error3") + Utility.numberFormat(this.bankMoney - this.lockMoney));
                    } else {
                        this.withDrawMoney(this.operateMoney, '')
                    }
                    return;
                } else if (this.bankStatus == BankOperate.Transfer) {
                    max = this.bankMoney - this.lockMoney
                    if (this.operateMoney > this.bankMoney - this.lockMoney) {
                        ModuleManager.instance.toast(LanguageManager.t("clubbank_error4") + Utility.numberFormat(this.bankMoney - this.lockMoney));
                        return;
                    }
                }
                let self = this
                this.view.moneyInputPanelDeal(false, function () {
                    self.view.tipsPanelDeal(LanguageManager.t("clubbank_inputpassword"), 1)
                })
                this.view.moneyInputAnim(1)


            }
        }
    }
    moneyInputDeal(progress?) {
        let max
        if (this.bankStatus == BankOperate.Save) {
            max = this.carryMoney
        } else if (this.bankStatus == BankOperate.WithDraw) {
            max = this.bankMoney - this.lockMoney
        } else if (this.bankStatus == BankOperate.Transfer) {
            max = this.bankMoney - this.lockMoney
        }
        if (progress == undefined) {
            let num = this.view.moneyOperateInputBox.string == "" ? 0 : parseInt(this.view.moneyOperateInputBox.string)
            if (num > max) {
                num = max
            }
            this.view.moneyOperateInputBox.string = num + ""
            this.view.opSlider.progress = num / max
            this.view.opProgressbar.progress = num / max
        } else {
            let num = Math.floor(progress * max)
            this.view.moneyOperateInputBox.string = num + ""
            this.view.opProgressbar.progress = progress
        }
    }

    @bindButtonClickEvent("OperateCancelBtn")
    OperateCancelBtn() {
        this.bankStatus = BankOperate.Null
        this.view.operatePanelDeal(this.bankStatus)
        this.view.moneyInputAnim(2)
    }
    @bindButtonClickEvent("TransferBtn")
    TransferBtn() {
        this.bankStatus = BankOperate.FriendId
        this.view.operatePanelDeal(this.bankStatus)
    }
    @bindButtonClickEvent("RecordBtn")
    RecordBtn() {
        this.record()
    }
    @bindButtonClickEvent("SaveRecordToggle")
    SaveRecordToggle() {
        this.recordType = 0
        this.record()
    }
    @bindButtonClickEvent("TransferRecordToggle")
    TransferRecordToggle() {
        this.recordType = 1
        this.record()
    }
    @bindButtonClickEvent("CloseRecordBtn")
    CloseRecordBtn() {
        this.view.showRecord()
    }
    @bindButtonClickEvent("OperateFriendBtn")
    OperateFriendBtn() {

    }
    @bindButtonClickEvent("TipsMask")
    TipsMask() {
        this.bankStatus = BankOperate.Null
        this.view.tipsPanelDeal("")
        this.view.operatePanelDeal(this.bankStatus)
        this.view.moneyInputAnim(2)
    }
    @bindButtonClickEvent("PasswordServiceBtn")
    PasswordServiceBtn() {
        this.view.tipsPanelDeal(LanguageManager.t("clubbank_resetpassword"), 0)
    }
    onShow(intentData) {
        this.recorRequstTime = [0, 0]
        this.clubData = intentData
        this.isSetPassword = intentData.isSetPwd
        this.bankStatus = this.isSetPassword ? BankOperate.Null : BankOperate.SetPassword
        this.view.bankInit(this.isSetPassword, this.clubData.isTransfer)
        if (this.isSetPassword) {
            this.view.moduleShow(1)
        } else {
            this.view.moduleShow(0)
        }
        let self = this
        this.getSelfCurrencyData(function (data) {
            self.bankMoney = data.chipClubSafebox
            self.carryMoney = data.chipClub
            // self.lockMoney = data.freez
            self.view.updateMoney(data.chipClubSafebox, data.chipClub);
        })
        this.view.moneyOperateInputBox.node.on('text-changed', function () {
            self.moneyInputDeal()
        }, self);
        this.view.opSlider.node.on('slide', function (slider: cc.Slider) {
            self.moneyInputDeal(slider.progress)

        }, self)
        this.eventBind("Event_Notify_Club_Transfer", function (content) {
            self.setTransferRed(content)
            self.clubData.haveTransfer = content
        })
        self.setTransferRed(intentData.haveTransfer)
    }
    setTransferRed(v, c?) {
        this.view.transferRed.active = v
        if (c) {
            EventManager.instance.dispatch("Event_Notify_Club_Transfer", false)
            this.clearRed()
        }
    }
    @implementFunction('onSelfCurrencyDataUpdate')
    protected on_selfCurrencyDataUpdate(data: IUserCurrencyData) {
        this.bankMoney = data.chipClubSafebox
        this.carryMoney = data.chipClub
        // this.lockMoney = data.freez
        this.view.updateMoney(data.chipClubSafebox, data.chipClub);
    }
    private _get_http(url, param, success, fail?, showNetPrompt?) {
        param.userClubId = this.clubData.userClubId
        let requestData: IHttpRequestData = {
            baseUrl: url,
            params: param
        }
        if (showNetPrompt) {
            requestData.showNetPrompt = true
        }
        this.apiHttpGet(requestData, function (retData) {
            success(retData.data)
        }, (retData) => {
            fail && fail(retData)
        })
    }
    clearRed() {
        let url = "club/user/removeRedPoint?"
        let param = {
            clubRedPointType: "bank",
        }
        this._get_http(url, param, function (data) {
            if (data) {
                cc.log("club transfer red clear success !!")
            }
        })
    }
    setPassward(password) {
        let url = "club/user/setFirstPassword?"
        let param = {
            password: password,
        }
        let self = this
        this._get_http(url, param, function () {
            self.isSetPassword = true
            club_utils.clubInfo.isSetPwd = true
            self.bankStatus = BankOperate.Null
            self.view.bankInit(true, self.clubData.isTransfer)
            self.view.moduleShow(2)
            self.view.pauseBtnClick(false)
        }, function (retData) {
            ModuleManager.instance.toast(retData.msg);
            self.view.pauseBtnClick(false)
        })
    }
    saveMoney(count, password) {
        let self = this
        let url = "club/user/depositBalance?"
        let param = {
            coins: count,
            password: "0000",
        }
        this._get_http(url, param, function () {
            // self.view.passwordAnim(true, function () {
            //     self.OperateCancelBtn()
            //     self.view.tipsPanelDeal(LanguageManager.t("clubbank_saveopsuc"), 0)
            //     self.getSelfCurrencyData(null, true);
            //     self.recorRequstTime[0] = 0
            //     self.view.pauseBtnClick(false)
            // })
            self.OperateCancelBtn()
            self.view.tipsPanelDeal(LanguageManager.t("clubbank_saveopsuc"), 0)
            self.getSelfCurrencyData(null, true);
            self.recorRequstTime[0] = 0
            self.view.pauseBtnClick(false)
        }, function (data) {
            self.OperateCancelBtn()
            self.opErrorDeal(data)
        }, true)
    }
    withDrawMoney(count, password) {
        let self = this
        let url = "club/user/withdrawBalance?"
        let param = {
            coins: count,
            password: "0000",
        }
        this._get_http(url, param, function () {
            // self.view.passwordAnim(true, function () {
            //     self.OperateCancelBtn()
            //     self.view.tipsPanelDeal(LanguageManager.t("clubbank_withdrawopsuc"), 0)
            //     self.getSelfCurrencyData(null, true);
            //     self.recorRequstTime[0] = 0
            //     self.view.pauseBtnClick(false)

            // })
            self.OperateCancelBtn()
            self.view.tipsPanelDeal(LanguageManager.t("clubbank_withdrawopsuc"), 0)
            self.getSelfCurrencyData(null, true);
            self.recorRequstTime[0] = 0
            self.view.pauseBtnClick(false)
        }, function (data) {
            self.OperateCancelBtn()
            self.opErrorDeal(data)
        }, true)
    }

    transferMoney(count, password, targetUserId) {
        let self = this
        let url = "club/user/transferMoney?"
        let param = {
            coins: count,
            password: password,
            toUserId: targetUserId
        }
        this._get_http(url, param, function () {
            self.view.passwordAnim(true, function () {
                self.view.tipsPanelDeal(LanguageManager.t("clubbank_transferopsuc"), 0)
                self.getSelfCurrencyData(null, true);
                self.recorRequstTime[1] = 0
                self.view.pauseBtnClick(false)
            })
        }, function (data) {
            self.opErrorDeal(data)
        })
    }
    opErrorDeal(data) {
        let self = this
        if (data.code == "U00042") {
            AudioManager.instance.playSound('sound/public/password_incorrect')
            self.view.passwordAnim(false, function () {
                self.view.tipsPanelDeal(data.msg, 1)
            })
        } else {
            self.view.tipsPanelDeal(data.msg, 1)
        }
        self.view.pauseBtnClick(false)
    }

    record() {
        let now = new Date().getTime()
        if (now - this.recorRequstTime[this.recordType] > 10000) {
            this.recorRequstTime[this.recordType] = new Date().getTime()
            if (this.recordType == 0) {
                this.operateRecord()
            } else {
                this.operateTransferRecord()
            }
        } else {
            this.view.showRecord(this.recordType)
            if (this.recordType == 1) {
                this.setTransferRed(false, true)
            }
        }
    }
    operateRecord() {
        let self = this
        let url = "club/oplog/queryAccessOplog?"
        let param = {
            pageNum: 1,
        }
        this._get_http(url, param, function (data) {
            self.recorRequstTime[0] = new Date().getTime()
            self.view.showRecord(0, data.list)
        }, function (retData) {
            self.recorRequstTime[0] = 0
            ModuleManager.instance.toast(retData.msg);
            self.view.showRecord(0)
        })
    }
    operateTransferRecord() {
        let self = this
        let url = "club/oplog/queryBalanceTranlog?"
        let param = {
            pageNum: 1,
        }
        this._get_http(url, param, function (data) {
            self.recorRequstTime[1] = new Date().getTime()
            self.view.showRecord(1, data.list)
            self.setTransferRed(false, true)
        }, function (retData) {
            self.recorRequstTime[1] = 0
            ModuleManager.instance.toast(retData.msg);
            self.view.showRecord(1)
            self.setTransferRed(false, true)
        })
    }


}
